module.exports = __webpack_public_path__ + "img/wakenovel.a6280566.png";